{
  "BJ": {
    "buyUsdt": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "sellUsdt": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "sellGiftCard": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "buyGiftCard": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "platformSubscription": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "fund1xBet": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "withdrawal1xBet": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "fundWallet": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "withdrawalWallet": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "fundBetWinner": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "withdrawalBetWinner": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "fundMelbet": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "withdrawalMelbet": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "fundEightStarz": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "withdrawalEightStarz": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "withdrawalAffiliation": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "fund1Win": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "withdrawal1Win": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "subscription": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    },
    "storeOperation": {
      "MTN": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "MOOV": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"],
      "CELTIS": ["qos", "paydunya", "sckaler", "feexpay", "senvo", "simpilot", "none", "manual"]
    }
  },
  "BF": {
    "buyUsdt": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "sellUsdt": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "sellGiftCard": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "buyGiftCard": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "platformSubscription": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "fund1xBet": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "withdrawal1xBet": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "fundWallet": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "withdrawalWallet": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "fundBetWinner": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "withdrawalBetWinner": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "fundMelbet": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "withdrawalMelbet": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "fundEightStarz": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "withdrawalEightStarz": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "withdrawalAffiliation": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "fund1Win": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "withdrawal1Win": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "subscription": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    },
    "storeOperation": {
      "ORANGE": ["paydunya", "touchpay", "none", "manual"],
      "MOOV": ["paydunya", "touchpay", "none", "manual"]
    }
  },
  "CI": {
    "buyUsdt": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "sellUsdt": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "sellGiftCard": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "buyGiftCard": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "platformSubscription": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "fund1xBet": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "withdrawal1xBet": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "fundWallet": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "withdrawalWallet": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "fundBetWinner": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "withdrawalBetWinner": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "fundMelbet": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "withdrawalMelbet": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "fundEightStarz": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "withdrawalEightStarz": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "withdrawalAffiliation": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "fund1Win": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "withdrawal1Win": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "subscription": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    },
    "storeOperation": {
      "MTN": ["touchpay", "paydunya", "none", "manual"],
      "ORANGE": ["touchpay", "paydunya", "none", "manual"],
      "MOOV": ["touchpay", "paydunya", "none", "manual"],
      "WAVE": ["touchpay", "paydunya", "none", "manual"]
    }
  },
  "ML": {
    "buyUsdt": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "sellUsdt": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "sellGiftCard": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "buyGiftCard": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "platformSubscription": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "fund1xBet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "withdrawal1xBet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "fundWallet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "withdrawalWallet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "fundBetWinner": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "withdrawalBetWinner": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "fundMelbet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "withdrawalMelbet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "fundEightStarz": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "withdrawalEightStarz": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "withdrawalAffiliation": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "fund1Win": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "withdrawal1Win": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "subscription": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    },
    "storeOperation": {
      "ORANGE": ["paydunya", "none", "manual"],
      "MOOV": ["paydunya", "none", "manual"]
    }
  },
  "SN": {
    "buyUsdt": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "sellUsdt": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "sellGiftCard": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "buyGiftCard": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "platformSubscription": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "fund1xBet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "withdrawal1xBet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "fundWallet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "withdrawalWallet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "fundBetWinner": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "withdrawalBetWinner": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "fundMelbet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "withdrawalMelbet": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "fundEightStarz": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "withdrawalEightStarz": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "withdrawalAffiliation": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "fund1Win": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "withdrawal1Win": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "subscription": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    },
    "storeOperation": {
      "ORANGE": ["paydunya", "none", "manual"],
      "FREE": ["paydunya", "none", "manual"]
    }
  },
  "TG": {
    "buyUsdt": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "sellUsdt": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "sellGiftCard": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "buyGiftCard": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "platformSubscription": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "fund1xBet": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "withdrawal1xBet": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "fundWallet": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "withdrawalWallet": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "fundBetWinner": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "withdrawalBetWinner": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "fundMelbet": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "withdrawalMelbet": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "fundEightStarz": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "withdrawalEightStarz": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "withdrawalAffiliation": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "fund1Win": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "withdrawal1Win": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "subscription": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    },
    "storeOperation": {
      "TMONEY": ["qos", "paydunya", "none", "manual"],
      "MOOV": ["qos", "paydunya", "none", "manual"]
    }
  },
  "GA": {
    "buyUsdt": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "sellUsdt": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "sellGiftCard": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "buyGiftCard": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "platformSubscription": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "fund1xBet": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "withdrawal1xBet": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "fundWallet": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "withdrawalWallet": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "fundBetWinner": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "withdrawalBetWinner": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "fundMelbet": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "withdrawalMelbet": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "fundEightStarz": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "withdrawalEightStarz": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "withdrawalAffiliation": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "fund1Win": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "withdrawal1Win": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "subscription": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    },
    "storeOperation": {
      "AIRTEL": ["touchpay", "none", "manual"],
      "MOOV": ["touchpay", "none", "manual"]
    }
  },
  "NE": {
    "buyUsdt": {
      "AIRTEL": ["ipay", "none", "manual"],
      "MOOV": ["ipay", "none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "sellUsdt": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "sellGiftCard": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "buyGiftCard": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "platformSubscription": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "fund1xBet": {
      "AIRTEL": ["ipay", "none", "manual"],
      "MOOV": ["ipay", "none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "withdrawal1xBet": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "fundWallet": {
      "AIRTEL": ["ipay", "none", "manual"],
      "MOOV": ["ipay", "none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "withdrawalWallet": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "fundBetWinner": {
      "AIRTEL": ["ipay", "none", "manual"],
      "MOOV": ["ipay", "none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "withdrawalBetWinner": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "fundMelbet": {
      "AIRTEL": ["ipay", "none", "manual"],
      "MOOV": ["ipay", "none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "withdrawalMelbet": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "fundEightStarz": {
      "AIRTEL": ["ipay", "none", "manual"],
      "MOOV": ["ipay", "none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "withdrawalEightStarz": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "withdrawalAffiliation": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "fund1Win": {
      "AIRTEL": ["ipay", "none", "manual"],
      "MOOV": ["ipay", "none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "withdrawal1Win": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "subscription": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    },
    "storeOperation": {
      "AIRTEL": ["none", "manual"],
      "MOOV": ["none", "manual"],
      "NITA": ["none", "manual"],
      "AMANA": ["none", "manual"],
      "ZEYNA": ["none", "manual"]
    }
  }
}
